import { Components, Theme } from '@mui/material';

export const listOverrides: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
    }),
  },
};

export const listItemButtonOverrides: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
      paddingBlock: '8px',
    }),
  },
};
